"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRetrieveCustomerLocation = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const ErrorResolver_1 = require("../../../../contexts/ErrorResolver");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const useClient_1 = require("../../../../hooks/useClient");
const useRetrieveCustomerLocation = ({ onSuccess, onError, onSettled, errorApproach = "modal" }) => {
    const client = (0, useClient_1.useClient)(); // TODO: use spg client
    const { resolveError } = (0, useRequiredContext_1.useRequiredContext)(ErrorResolver_1.ErrorResolverContext);
    const defaultErrorHandler = (error) => {
        console.error(error);
        resolveError({
            title: "Unable to retrieve saved location",
            approach: errorApproach,
            hideCloseIcon: true,
            retry: () => mutate()
        });
    };
    const [mutate, { isLoading, error }] = (0, react_query_1.useMutation)(() => client.retailCustomers.retrieveLocation(), {
        onSuccess,
        onError: onError || defaultErrorHandler,
        onSettled
    });
    return (0, react_1.useMemo)(() => ({
        isLoading,
        error,
        mutate
    }), [isLoading, error, mutate]);
};
exports.useRetrieveCustomerLocation = useRetrieveCustomerLocation;
//# sourceMappingURL=useRetrieveCustomerLocation.js.map